export const isAllContentNull = (a: Record<string, any>) => {
  const values = Object.values(a);

  return values.length > 0 && !values.some(value => value != null);
};

export function hasNullValues <T> (a: T): boolean {
  return Object.values(a).some(value => value == null);
}
